import { useEffect, useState } from 'react';

const findScrollableAncestor = (el: HTMLElement | null): HTMLElement | null => {
  let node = el?.parentElement ?? null;
  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return node;
    }
    node = node.parentElement;
  }
  return document.scrollingElement as HTMLElement | null;
};

export const useScrollableAncestor = (anchor: HTMLElement | null) => {
  const [scrollParent, setScrollParent] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setScrollParent(anchor ? findScrollableAncestor(anchor) : null);
  }, [anchor]);

  return scrollParent;
};
